module.exports = __webpack_public_path__ + "static/media/EmptyPlayer.72968d52.png";